import React from 'react';
import style from './style.module.scss';
import { Button } from '../../button';

export const UserSingleDetail = (props: {
    title: React.ReactNode;
    info?: React.ReactNode | string | number | null;
    buttonText?: string;
    buttonFunctionality?: () => void;
    style?: React.CSSProperties;
    buttonDisabled?: boolean;
}) => {
    return (
        <>
            <div className={style.container} style={props.style}>
                <div className={style.title}>{props.title}</div>
                <div
                    className={
                        props.buttonFunctionality && props.buttonText
                            ? style.info_and_button
                            : style.info
                    }
                >
                    {props.info ? props.info : '-'}
                </div>
                {props.buttonText && props.buttonFunctionality && (
                    <Button
                        onClick={props.buttonFunctionality}
                        disabled={props.buttonDisabled}
                        variant="secondary"
                    >
                        {props.buttonText}
                    </Button>
                )}
            </div>
        </>
    );
};
